import { type FC } from "react";

import { Dialog } from "@fronterahealth/frontera-ui-components";

import { ProgressSummaryMissingText } from "@pages/Templates/ProgressSummaryMissingText";
import { type TPFieldTypeValue } from "@pages/Templates/constants";

export const ProgressSummaryMissingDialog: FC<{
  open: boolean;
  missingTypes: readonly TPFieldTypeValue[];
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ open, missingTypes, onConfirm, onCancel }) => (
  <Dialog
    title="Progress Summary field missing"
    open={open}
    setOpen={(open) => {
      if (!open) onCancel();
    }}
    primaryButton={{ text: "Save anyway", onClick: onConfirm }}
    secondaryButton={{ text: "Go back", onClick: onCancel }}
    size="xl"
  >
    <p className="text-sm text-text-secondary">
      <ProgressSummaryMissingText missingTypes={missingTypes} />
    </p>
  </Dialog>
);
